import controller from './DynamicComponentCtrl';

export default {
    controller,
    bindings: {
        props: '<',
        name: '<',
        prefix: '@',
        variant: '<',
        suffix: '@',
        defaultName: '@',
        defaultVariant: '@'
    }
};
